module.exports = __webpack_public_path__ + "static/media/authSuccess.a7357a9f.svg";